/**
 * SF-156 Component 4: single shared freshness value per Dossier roster row. Not tab-dependent —
 * the design source lists the row's freshness indicator once, under "every row, regardless of
 * active tab." Drives both the row's always-visible freshness indicator and the "Freshness"
 * sort-key option on both the Resources and Military `<select>`s (`dossierSort.ts`) — there is one
 * Freshness value per row, not one per report type.
 */

import type { DossierProvinceRow } from '../types/dossier';

/** Max `capturedAtTick` across all four intel reports on file, or `null` if none are. */
export function latestReportTick(row: DossierProvinceRow): number | null {
  const ticks = [
    row.latestCb?.capturedAtTick,
    row.latestSom?.capturedAtTick,
    row.latestSurvey?.capturedAtTick,
    row.latestInfiltrate?.capturedAtTick,
  ].filter((t): t is number => t != null);
  return ticks.length > 0 ? Math.max(...ticks) : null;
}
